export default __webpack_public_path__ + "static/media/kitchen4-afterB-2048w.671ec969.png";